import BuildCode from "./Component/BuildCode";
import { Grid } from "@mui/material";
import InvitationCode from "./Component/InvitationCode";
import useIsMobileView from "hooks/useIsMobileView";

function WrapCode({ getAllReferrals }) {
  const isMobileView = useIsMobileView();

  return (
    <Grid item xs={12} marginTop={5}>
      <Grid container spacing={6}>
        <Grid item xs={12} md={6} order={isMobileView ? 2 : 1}>
          <BuildCode getAllReferrals={getAllReferrals} />
        </Grid>

        <Grid item xs={12} md={6} order={isMobileView ? 1 : 2}>
          <InvitationCode />
        </Grid>
      </Grid>
    </Grid>
  );
}
export default WrapCode;
